import * as React from 'react';

const Feedbacks: React.FC<{}> = () => {
  return <></>;
};

export default Feedbacks;
